import React from "react";

function ClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
    >
      <path
        d="M9.74905 16.4323C7.98451 16.4323 6.2596 15.9505 4.79244 15.0477C3.32529 14.1448 2.18178 12.8617 1.50652 11.3604C0.831258 9.85905 0.65458 8.20705 0.998824 6.61327C1.34307 5.01949 2.19277 3.55551 3.44049 2.40646C4.6882 1.25741 6.27789 0.474897 8.00852 0.157875C9.73915 -0.159148 11.533 0.00356015 13.1632 0.625422C14.7934 1.24728 16.1868 2.30037 17.1671 3.65151C18.1475 5.00265 18.6707 6.59116 18.6707 8.21616C18.6707 10.3952 17.7307 12.485 16.0576 14.0259C14.3845 15.5667 12.1152 16.4323 9.74905 16.4323ZM9.74905 14.7896C11.1604 14.7894 12.5401 14.4037 13.7134 13.6814C14.8868 12.9591 15.8013 11.9325 16.3412 10.7316C16.8811 9.5307 17.0223 8.20931 16.7467 6.93453C16.4712 5.65975 15.7914 4.48884 14.7933 3.56985C13.7952 2.65085 12.5236 2.02506 11.1393 1.77158C9.755 1.5181 8.32018 1.64833 7.01625 2.1458C5.71232 2.64327 4.59784 3.48563 3.81375 4.56638C3.02965 5.64713 2.61114 6.91773 2.61114 8.21751C2.61114 9.08069 2.79578 9.93541 3.15451 10.7329C3.51324 11.5303 4.03904 12.2549 4.70188 12.8652C5.36471 13.4755 6.1516 13.9595 7.0176 14.2897C7.8836 14.6199 8.81176 14.7898 9.74905 14.7896ZM10.6475 8.21751H14.2091V9.85481H8.85645V4.10876H10.6475V8.21751Z"
        fill="var(--primary-gray)"
      />
    </svg>
  );
}

export default ClockIcon;
